<template>
    <section class="interview-title light blue">
        <div class="css-grid panel-left">
            <div class="bg" style="background-image: url(/static/img/pages/interview-caro.jpg)"></div>

            <div class="content-wrapper">
                <div class="content light blue">
                    <h3>Interview Caro&nbsp;Bakker</h3>
                    <h2>Intensief betrokken bij de kwaliteit van onderwijs</h2>
                    <button @click="openInterview">Lees het interview</button>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    .bg{
        background-position: 100% center !important;
    }
</style>

<script>
    import InterviewCaro from '@/app/pages/sub/InterviewCaro';

    export default {
        name: 'MedewerkerInterview',
        meta: {
            title: 'MedewerkerInterview',
            color: '#36B1CA'
        },

        components: {
        },

        methods: {
            openInterview()
            {
                this.$emit( 'openOverlay', InterviewCaro );
            }
        }
    };
</script>
